export const optionsVslim = {title: 'Confirmation', cancelLabel: 'Annuler', okLabel: 'Confirmer'}
